import type { VideoJob } from '../services/local-video';

const failures: Record<string, string> = {
  publication_failed: 'The renderer could not save the finished export.',
  capture_failed: 'The renderer could not finish capturing the frames.',
  capture_timeout: 'Frame capture exceeded its time limit.',
  processing_deadline: 'The render exceeded its processing time limit.',
  processing_stalled: 'The renderer stopped reporting progress.',
  worker_interrupted: 'The renderer was interrupted before the export finished.',
  hardware_unavailable: 'The cloud renderer needs attention.',
  gpu_startup_timeout: 'The cloud renderer could not start.',
  renderer_unavailable: 'The video service could not reach the renderer.',
};

export function videoFailureMessage(job: VideoJob): string | undefined {
  if (job.state !== 'failed' && job.state !== 'submission_failed') return;
  const reason = job.failureCode ? failures[job.failureCode] : undefined;
  return reason ?? 'No error details were supplied.';
}

/** Export only settings already available to the account; exclude URLs and identity fields. */
export function videoJobSettings(job: VideoJob) {
  const { id, title, state, phase, failureCode, attempts, createdAt, updatedAt, frameProgress,
    preset, durationSeconds, timelineDurationSeconds, exportRange, cameraStyleVersion, camera,
    distance, cameraGimbal, cameraAngle, mapStyle, terrainExaggeration, hidePlaces,
    unitSystem, line, presentation, trackAppearance, depthOfField, cinematicSequence } = job;
  return { version: 1, jobId: id, title, state, phase, failureCode, attempts, createdAt, updatedAt,
    frameProgress, preset, durationSeconds, timelineDurationSeconds, exportRange, cameraStyleVersion,
    camera, distance, cameraGimbal, cameraAngle, mapStyle, terrainExaggeration, hidePlaces,
    unitSystem, line, presentation, trackAppearance, depthOfField, cinematicSequence };
}
